import {config} from '../config';

export default {
    getLocalizationFileName: () => config.data.localization.localizationFileName,
    getLocalizationKey: () => config.data.localization.localizationKey,
    getLocalizationMapping: () => config.data.localization.localizationMapping,
};
